/*=============================================== HighlightPage ===============================================*/

import { Highlight } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const HighlightPage = () => {
    const items: ItemType[] = [
        {
            content: <Highlight highlightedText="Hello">Hello world</Highlight>,
            code: '<Highlight highlightedText="Hello">Hello world</Highlight>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "highlightedText",
            type: "string",
            required: true,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default HighlightPage
